module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0060.jpg?v=244b7600";